import { getAllRoles, getRoleByIdOrSlug, updateRole } from '../../../modules/users/roles/roles.repository';
import { Role, UpdateRolePayload } from '../../../modules/users/roles/types';
import { Account, UpdateAccountPayload } from '../../../modules/users/types';
import { sendResetPasswordEmail, updateAccount } from '../../../modules/users/users.repository';

export const getRoleUseCase = async (id?: string) : Promise<Role> => {
  return getRoleByIdOrSlug(id);
};

export const getAllRolesUseCase = async () : Promise<Role[]> => {
  return getAllRoles();
};

export const updateAccountUseCase = async (id: number, payload: UpdateAccountPayload): Promise<Account> => {
  const data = await updateAccount(id, payload);
  return data;
};

export const updateRoleUseCase = async (
  id: number,
  updateRolePayload: UpdateRolePayload,
): Promise<void> => {
  await updateRole(id, updateRolePayload);
};

export const sendResetPasswordEmailUseCase = async (
  id: number,
): Promise<void> => {
  await sendResetPasswordEmail(id);
};
